import { Button, TextField } from '@mui/material'
import { useFormik } from 'formik'
import { useTranslation } from 'react-i18next'

import { HelperWrapper, ModalWrapper } from 'src/components'
import { useLibraryImpactSuggestion } from 'src/hooks'
import { IImpactLibrarySuggestDto } from 'src/types'

import { libraryImpactSuggestionSchema } from 'src/common/validations'
import { useStyles } from './styles'

interface IProps {
  open: boolean
  handleClose: () => void
}

export const ImpactLibrarySuggestion = ({ open, handleClose }: IProps) => {
  const [t] = useTranslation()
  const { mutateAsync: suggest } = useLibraryImpactSuggestion()
  const classes = useStyles()
  const { handleChange, values, dirty, isSubmitting, errors, handleSubmit } =
    useFormik<IImpactLibrarySuggestDto>({
      async onSubmit(val, { resetForm }) {
        const resp = await suggest(val)
        if (!resp) return

        resetForm()
        handleClose()
      },
      initialValues: { message: '' },
      validationSchema: libraryImpactSuggestionSchema,
    })

  return (
    <ModalWrapper open={open} onClose={handleClose} className={classes.suggestionModal}>
      <form className={classes.suggestionForm} onSubmit={handleSubmit}>
        <TextField
          variant="filled"
          fullWidth
          onChange={handleChange}
          value={values.message}
          label={t('error-logs-message-column.v')}
          id="message"
          name="message"
          autoFocus
          type="text"
          multiline
          rows={5}
          FormHelperTextProps={{
            error: !!errors.message,
          }}
          helperText={errors.message ? t(errors.message) : ' '}
        />
        <Button
          fullWidth
          type="submit"
          disabled={!dirty || isSubmitting || !!Object.keys(errors).length}
        >
          <HelperWrapper t="make-suggestion-button-text" />
        </Button>
      </form>
    </ModalWrapper>
  )
}
